import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { playSound } from 'core/helpers'
import { T } from 'components/misc'
import { MessageBasic } from './messages/MessageDefault'

function TypingIndicator({ conversationUid, showUntil, user, scrollToBottom }) {
  const [show, setShow] = useState(false)
  const [typingTimeoutId, setTypingTimeoutId] = useState(null)
  const [sound, setSound] = useState({ pause: () => {} })

  const endTyping = () => {
    setShow(false)
    sound.pause()
    clearTimeout(typingTimeoutId)
  }

  const startTyping = () => {
    const typeDuration = parseInt(showUntil) * 1000 - Date.now()
    if (typeDuration > 0) {
      setShow(true)
      setTypingTimeoutId(setTimeout(endTyping, typeDuration))
      setSound(playSound('keyboard', { loop: true }))
      scrollToBottom()
    }
  }

  useEffect(() => {
    endTyping()
    if (showUntil > Math.floor(Date.now() / 1000)) {
      startTyping()
    }
  }, [conversationUid, showUntil])

  return show && (
    <MessageBasic time={<T>basic.textingNow</T>} user={user}>
      <div className="typing-indicator">
        <div className="typing-indicator-circle bounce1"/>
        <div className="typing-indicator-circle bounce2"/>
        <div className="typing-indicator-circle bounce3"/>
      </div>
    </MessageBasic>
  )
}

TypingIndicator.propTypes = {
  conversationUid: PropTypes.string,
  showUntil: PropTypes.number,
  user: PropTypes.object,
  scrollToBottom: PropTypes.func,
}

export default TypingIndicator
